import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export async function getDocumentMetadata(url) {
  try {
    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;
    const numPages = pdf.numPages;
    return { pdf, numPages };
  } catch (error) {
    console.error('Error loading PDF document:', error);
    return { pdf: null, numPages: 0 };
  }
}

export async function renderPageToCanvas({ pdf, pageNumber, canvas, scale = 1 }) {
  try {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale: 1 }); // base scale

    // Get container dimensions
    const container = canvas.parentElement;
    const containerWidth = container.clientWidth;
    const scaleToFit = containerWidth / viewport.width;

    const scaledViewport = page.getViewport({ scale: scaleToFit });

    // Set canvas dimensions
    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;

    const context = canvas.getContext('2d');

    const renderContext = {
      canvasContext: context,
      viewport: scaledViewport,
    };

    await page.render(renderContext).promise;
  } catch (error) {
    console.error(`Error rendering page ${pageNumber}:`, error);
  }
}
